module.exports = __webpack_public_path__ + "static/scrabblista-mobile-2.323b1d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-mobile-2.png
// module id = 626
// module chunks = 230197332751855